import React, { useEffect, useState } from 'react';
import KeyValue from '../common/KeyValue'
import CollapsibleCard from '../common/CollapsibleCard'
import { getEmailDetails, getUserProfile } from "../../../helpers/mailbox"
import { getUserSetting, isPaiedUser, contactDtonomy } from "../../../helpers/get_permission"


export default function EmailDetailsCard() {
    const {origDate, from, sender} = getEmailDetails();
    const [payment, setPayment] = useState(false);
    useEffect(() => {
        let userEmail = getUserProfile().emailAddress;
        isPaiedUser(userEmail).then(
            paid => {
                if(paid) {
                    console.log("this is a vip user: "+ userEmail)
                    setPayment(true)
                } else {
                    console.log("this is a free user "+ userEmail)
                }
            }
        )
      }, []);
    const origDateDisplay = origDate.toLocaleString([], {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }
    );
    return (
        <CollapsibleCard header="Email Details" ctrlName="emailDetails" isOpen={true}>
              <KeyValue label="Origination Date:" value={origDateDisplay}/>
              <KeyValue label="From:" value={<>{from.displayName}<br/>{from.emailAddress}</>} />
              <KeyValue label="Sender:" value={<>{sender.displayName}<br/>{sender.emailAddress}</>}/>

           
        {//comment out to allow content for free user
        /* {
            (payment == false) && (<div>
                <div className="overlay">
                    <small className="font-weight-bold">Please contact <a href="" onClick={contactDtonomy} target="_blank" rel="noreferrer">DTonomy Inc.</a> to unlock the content</small>
                </div>
                <div className="blur">
                  <KeyValue label="Origination Date:" value="Value Hidden"/>
                  <KeyValue label="From:" value={<>"Value Hidden"<br/>"Value Hidden"</>} />
                  <KeyValue label="Sender:" value={<>"Value Hidden"<br/>"Value Hidden"</>}/>
                </div>
            </div>)
        }
        {
            (payment && <div>
                <div>
                  <KeyValue label="Origination Date:" value={origDateDisplay}/>
                  <KeyValue label="From:" value={<>{from.displayName}<br/>{from.emailAddress}</>} />
                  <KeyValue label="Sender:" value={<>{sender.displayName}<br/>{sender.emailAddress}</>}/>
                </div>
            </div>)
        } */}
        </CollapsibleCard>
    );
}
